var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nrs-footer"},[_c('div',{staticClass:"nrs-footer-copyright"},[_vm._v("\n        Copyright ©\n        "+_vm._s(_vm.copyrightyear)+"\n        NetRoadshow, Inc. All rights reserved.\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }